var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentplan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2165_14885)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#55D24C",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2165_14885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4976 26.4844H8V28.572C8.00158 29.8293 8.97599 30.8708 10.2306 30.9562C10.2574 30.9524 10.2844 30.9501 10.3115 30.9499H22.4495C21.8368 30.2861 21.497 29.4157 21.4976 28.5123V26.4844Z",
    fill: "#55D24C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7806 10.5485L11.6797 25.3316H22.0741C22.3926 25.3316 22.6507 25.5899 22.6507 25.9082V28.513C22.6507 29.768 23.652 30.8384 24.8809 30.9506H25.0775C25.1091 30.9508 25.1406 30.9535 25.1717 30.9589C26.4903 30.9141 27.5361 29.8322 27.5363 28.513V10.7323C27.5361 10.1239 27.7377 9.53263 28.1091 9.05083H13.3046C12.4705 9.04452 11.7889 9.71462 11.7806 10.5485ZM14.2497 12.9913H19.7111C20.0295 12.9913 20.2877 13.2494 20.2877 13.5679C20.2877 13.8864 20.0295 14.1445 19.7111 14.1445H14.2497C13.9312 14.1445 13.6731 13.8864 13.6731 13.5679C13.6731 13.2494 13.9312 12.9913 14.2497 12.9913ZM14.2497 17.1142H24.4372C24.7557 17.1142 25.0138 17.3723 25.0138 17.6908C25.0138 18.0093 24.7557 18.2674 24.4372 18.2674H14.2497C13.9312 18.2674 13.6731 18.0093 13.6731 17.6908C13.6731 17.3723 13.9312 17.1142 14.2497 17.1142ZM14.2497 21.2371H24.4372C24.7557 21.2371 25.0138 21.4952 25.0138 21.8137C25.0138 22.1322 24.7557 22.3903 24.4372 22.3903H14.2497C13.9312 22.3903 13.6731 22.1322 13.6731 21.8137C13.6731 21.4952 13.9312 21.2371 14.2497 21.2371Z",
    fill: "#55D24C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3446 9.1016C29.4382 9.09552 28.6978 9.82397 28.6895 10.7304V18.7135H31.9997V10.7304C31.9913 9.82397 31.2509 9.0953 30.3446 9.1016Z",
    fill: "#55D24C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2165_14885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2165_14885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 554.667,
    height: 554.667,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentplan);
export default __webpack_public_path__ + "static/media/paymentplan.3f952859953ec473cf5399dddf9f32a6.svg";
export { ForwardRef as ReactComponent };